<template>
  <div class="organization">
    <div>
      <h2>{{ org.name }}</h2>
    </div>
    <br>
    <v-container fluid>
      <v-layout align-content-space-around justify-start column fill-height>
        <api-client
          v-for="client in org.apiClients"
          v-bind:client="client"
          v-bind:auth="auth"
          v-bind:key="client.clientId">
        </api-client>
      </v-layout>
    </v-container>

    <div class="mt-2">
      <api-client-modal :auth="auth" :show="showModal" :org="org" @close="showModal = false"></api-client-modal>
      <v-btn color="deep-orange" dark id="show-modal" @click="showModal = true">New client</v-btn>
    </div>
  </div>
</template>

<script>
import ApiClient from "./ApiClient";
import ApiClientModal from "./ApiClientModal";

export default {
  name: "api-organization",
  components: { ApiClient, ApiClientModal },
  props: ["auth", "org"],
  data() {
    return {
      apiClients: [],
      showModal: false
    };
  },
  created() {
    this.$on("api-client-update", () => {
      this.$parent.$emit("api-organization-update");
    });
  }
};
</script>

<style>
.page {
  width: 100%;
}

.content {
  width: 100%;
  max-width: none !important;
}

.organization {
  padding: 20px;
  width: 100%;
  max-width: none;
}

.client-grid {
  display: flex;
  flex-wrap: wrap;
}

.client-grid .client {
  width: 50%;
  padding-right: 30px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
</style>
